import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  private gtmId: string;
  private isInitialized = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject('googleTagManagerId') gtmId: string,
  ) {
    this.gtmId = gtmId;
  }

  init(): void {
    if (this.isInitialized || !this.gtmId) {
      return;
    }

    // Initialize the dataLayer
    window.dataLayer = window.dataLayer || [];

    // Push the GTM container start event. This boots the container's
    // tag-management runtime and fires "Consent Initialization - All Pages",
    // which the Cookiebot tag depends on. Running this from the app bundle
    // ('self') keeps it CSP-compliant — no inline script required.
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    // Load the GTM CONTAINER via gtm.js (NOT the gtag/js measurement endpoint)
    this.loadGtmScript();

    this.isInitialized = true;
  }

  private loadGtmScript(): void {
    const script = this.document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}`;
    const firstScript = this.document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
  }
}